import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { hasScope as hasScopeSelector } from 'selectors/scopes';

/**
 * @param {Object} args
 * @param {function | JSX.Element | null} [args.alternate]
 * @param {JSX.Element | null} [args.children]
 * @param {String[]} [args.names]
 * @param {String} [args.name]
 * @param {boolean} [args.some]
 */
const Scopes = ({
  alternate = null,
  children = null,
  names = [],
  name,
  some = false,
}) => {
  if (!Array.isArray(names)) {
    names = [names];
  }

  if (name) {
    names.push(name);
  }

  const hasScopes = useSelector(state => {
    const hasSingleScope = name => hasScopeSelector(state, name);

    return some ? names.some(hasSingleScope) : names.every(hasSingleScope);
  });

  const alternative =
    Boolean(alternate) && typeof alternate === 'function'
      ? alternate()
      : alternate;

  return hasScopes ? children : alternative;
};

Scopes.propTypes = {
  alternate: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  children: PropTypes.element,
  names: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  some: PropTypes.bool,
};

export default Scopes;
